import styled, { createGlobalStyle } from 'styled-components';

export const StyledModal = styled.div`
  .modal {
  }
`;

export const FullScreenMobileModalStyles = createGlobalStyle`
  @media (max-width: 576px) {
    .modal--full-screen-mobile {
      .ant-modal {
        width: 100% !important;
        max-width: 100%;
        margin: 0;
        top: 0;
        padding: 0;
        height: 100%;
      }

      .ant-modal-content {
        border-radius: 0;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }

      .ant-modal-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        > div {
          flex: 1;
          display: flex;
          flex-direction: column;

          > div {
            flex: 1;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
`;
